var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app-bar',{style:({ marginBottom: _vm.marginBottom + 'px' }),attrs:{"flat":"","height":"auto","color":"#99a4b3"}},[_c('div',{staticClass:"contact-info"},[_c('div',{staticClass:"bottom-margin-10"}),_c('ul',{staticClass:"tabMenu d-flex"},_vm._l((_vm.tabList),function(tab,index){return _c('li',{key:tab + index,staticClass:"col mt-0",class:index + 1 === 1
            ? { 'active-left': _vm.localTabNumber === 1 }
            : index + 1 === _vm.tabList.length
            ? { 'active-right': _vm.localTabNumber === _vm.tabList.length }
            : index + 1 === 2
            ? {
                'active-between-1': _vm.localTabNumber === 2,
              }
            : {
                'active-between-2': _vm.localTabNumber === 3,
              },on:{"click":function($event){return _vm.selectTab(index + 1)}}},[_c('div',{staticClass:"d-flex justify-start tab-label tab",class:{
            'justify-center': _vm.$mq === 'pc',
            'justify-start': _vm.$mq !== 'pc',
          }},[(tab.isIcon)?_c('v-img',{staticClass:"my-auto",class:{
              'margin-right-15': _vm.$mq === 'pc',
              'margin-right-10': _vm.$mq !== 'pc',
            },staticStyle:{"margin-left":"10px"},attrs:{"max-height":"18","max-width":"18","src":tab.icon_active !== undefined && _vm.localTabNumber === index + 1
                ? tab.icon_active
                : tab.icon}}):_vm._e(),_c('p',{staticClass:"font-size-min my-auto",class:{ 'mx-auto': !tab.isIcon }},[_vm._v(" "+_vm._s(tab.title)+" ")])],1)])}),0)])])}
var staticRenderFns = []

export { render, staticRenderFns }